"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * This is a [React](https://reactjs.org/) component for the Vanilla [Form](https://docs.vanillaframework.io/base/forms).
 *
 * Form controls have global styling defined at the HTML element level. Labels and most input types are 100% width of the `<form>` parent element.
 */
const Form = _ref => {
  let {
    children,
    className,
    inline,
    stacked,
    ...props
  } = _ref;
  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _classnames.default)(className, {
      "p-form": inline || stacked,
      "p-form--inline": inline,
      "p-form--stacked": stacked
    })
  }, props), children);
};
var _default = exports.default = Form;